import React from "react";
import Chart from "react-apexcharts";

export default function IncomeDistributionPieChart({
  title = "Pie Chart",

  labels = [],

  series = [],

  colors = ["#3B82F6", "#10B981", "#F59E0B", "#ef4444"],

  height = 280,

  showLegend = false,
}) {
  const options = {
    labels,

    colors,

    chart: {
      toolbar: { show: false },
    },

    legend: {
      show: showLegend,
      position: "bottom",
    },

    dataLabels: {
      enabled: false,
    },

    stroke: {
      colors: ["#ffffff"],
      width: 2,
    },

    plotOptions: {
      pie: {
        expandOnClick: false,
      },
    },
  };

  return (
    <div>
      <h4
        style={{
          fontSize: "20px",
          marginBottom: "10px",
          marginTop: "10px",
          fontWeight: "600",
          color: "#0A0A0A",
        }}
      >
        {title}
      </h4>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Chart options={options} series={series} type="pie" height={height} />
      </div>
    </div>
  );
}
